module.exports = __webpack_public_path__ + "static/media/pimeyes.46ae2a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners-hover/pimeyes.jpg
// module id = 2909
// module chunks = 1